import React from 'react';
import { Section } from './Section';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Tengo 68 años y hacía tiempo que buscaba algo para ejercitar la cabeza. Este cuadernillo me encantó porque no me trata como si fuera un nene. Lo hago después del desayuno y ya se me hizo costumbre.',
    name: 'Jorge Alberto',
    location: 'Mar del Plata'
  }, {
    quote: 'Lo que más me gustó es que puedo hacerlo a mi ritmo. Algunos ejercicios son fáciles, otros me cuestan un poco, pero todos me entretienen. Mi hija me lo regaló y le agradezco todos los días.',
    name: 'Norma S.',
    location: 'Rosario'
  }, {
    quote: 'Empecé a notar que me olvidaba cosas tontas y me preocupaba mucho. Desde que uso el kit me siento más despejada. No es magia, pero algo cambió y eso me da tranquilidad.',
    name: 'María Elena G.',
    location: 'Córdoba'
  }, {
    quote: 'Estoy jubilado y tenía demasiado tiempo libre sin saber qué hacer. Ahora empiezo el día con unos ejercicios y me pone de buen humor. Además lo imprimí para hacerlo con mi señora.',
    name: 'Héctor R.',
    location: 'Buenos Aires'
  }, {
    quote: 'A mis 72 años no quería un librito para niños. Este cuadernillo es serio, está bien hecho y me desafía sin agobiarme. Muy recomendable, lo uso todos los días.',
    name: 'Susana T.',
    location: 'La Plata'
  }];
  return <Section className="bg-white" data-id="element-229">
      <div className="text-center mb-12" data-id="element-230">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-231">
          Lo que dicen quienes ya lo usan ❤️
        </h2>
        <p className="text-xl text-gray-600" data-id="element-232">
          Adultos mayores que ya empezaron a entrenar su mente con el kit.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-233">
        {testimonials.map((t, idx) => <div key={idx} className={`bg-cream-dark p-8 rounded-2xl ${idx === testimonials.length - 1 ? 'md:col-span-2 md:max-w-xl md:mx-auto' : ''}`} data-id="element-234">
            <div className="flex text-[#e8a365] mb-4" data-id="element-235">
              {[1, 2, 3, 4, 5].map(star => <Star key={star} size={20} fill="currentColor" data-id="element-236" />)}
            </div>
            <p className="text-gray-800 text-lg mb-6 italic" data-id="element-237">"{t.quote}"</p>
            <div className="font-medium text-gray-900" data-id="element-238">
              {t.name}{' '}
              <span className="text-gray-500 font-normal" data-id="element-239">· {t.location}</span>
            </div>
          </div>)}
      </div>
    </Section>;
}